import { render, staticRenderFns } from "./DetailLogistics.vue?vue&type=template&id=8383c63e&"
import script from "./DetailLogistics.vue?vue&type=script&lang=js&"
export * from "./DetailLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports